import React from "react";
import { Link } from "react-router-dom";
import "../styles/components/HeroSection.css";

const HeroSection = () => {
  return (
    <section className="hero">
      <div className="container">
        <div className="hero-content">
          <div className="text-block">
            <h1>Psiholog Novi Sad – Psihološki Centar Clarity</h1>
            <h2>Mesto gde se sigurnost sreće sa rastom</h2>
            <p>
              Iz iskustva znamo da je svaki problem lakši kada niste sami. Zato smo
              ovde da vam budemo pouzdan partner na putu promene i ličnog razvoja.
            </p>
            <p>
              Naš pristup se oslanja na savremenu psihologiju, ali ono što nas vodi
              jeste stvaranje prostora u kojem se osećate sigurno, viđeno i prihvaćeno.
            </p>
            <p>
              Zajedno gradimo most između mesta gde se trenutno nalazite i mesta ka
              kojem želite da idete.
            </p>
            <div className="hero-actions">
              <Link to="/kontakt" className="btn btn-primary">Zakažite termin</Link>
              <Link to="/usluge" className="btn btn-ghost">Pogledajte usluge</Link>
            </div>
          </div>
          <img 
            fetchPriority="high" 
            src="/images/home-1.webp" 
            alt="Psiholog Novi Sad - Psihološki Centar Clarity, profesionalna psihološka pomoć i podrška"
            className="image-side"
            width="800"
            loading="eager"
          />
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
